import {
  EnumGoodsStatus,
  EnumPartitionID,
  EnumShowChannelType,
} from '../defines/enums'
import { URLQueries } from '../global_env/url_query'
import { isDyProgramH5 } from '../../js/env'
import { xenv } from '@didi/webx-js'
import { goodsInit } from '@didi/trade-sdk/lib/quartz-mall'
import { GlobalEnv } from '../global_env'
import { request } from '../api'
import { GlobalConfig } from '../config'
/**
 * 获取商品详情信息
 * @param {string|number} id - 商品 ID
 * @param {Object} [options] - 选项
 * @param {boolean} [options.isSpike] - 是否是秒杀
 */
export const getGoodsDetail = async (id, options) => {
  id = id || URLQueries.getQuery('id')
  if (!id) {
    throw new Error('获取商品详情需要商品 ID.')
  }
  try {
    const data = await goodsInit(id, {
      lang: GlobalEnv.lang,
      needFullData: true,
      token: GlobalEnv.loginInfo.token,
      source_id: GlobalEnv.channelId,
      city_id: GlobalEnv.locationInfo.cityId,
      lat: GlobalEnv.locationInfo.lat,
      lng: GlobalEnv.locationInfo.lng,
      show_version: URLQueries.getQuery('show_version'),
    })
    return Promise.resolve({
      goods: data.info,
      buyerList: data.buyerList,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * 获取商品详情信息
 * @param {string|number} id - 商品 ID
 * @param {Object} [options] - 选项
 * @param {boolean} [options.isSpike] - 是否是秒杀
 */
export const getGoodsDetailConfirm = async (id, options) => {
  id = id || URLQueries.getQuery('id')
  if (!id) {
    throw new Error('获取商品详情需要商品 ID.')
  }
  const isSpike =
    options && options.isSpike !== undefined ? !!options.isSpike : false
  const params = {
    id,
    token: GlobalEnv.loginInfo.token,
    source_id: GlobalEnv.channelId,
    city_id: GlobalEnv.locationInfo.cityId,
    lat: GlobalEnv.locationInfo.lat,
    lng: GlobalEnv.locationInfo.lng,
    show_version: URLQueries.getQuery('show_version'),
  }
  isSpike &&
    Object.assign(params, {
      pid: URLQueries.getQuery('pid') || 10002,
    })
  try {
    const data = await request.get(GlobalConfig.APIs.goodsDetailNormal, params)
    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * 判断商品是否不可用
 * @param {Object} goods - 商品信息，getGoodsDetail 的返回值里的 info
 * @return {boolean} 商品是否不可用
 */
export const isGoodsUnavailable = data =>
  Number(data.audit_status) === EnumGoodsStatus.Offline ||
  Number(data.balance_left) === 0

/**
 * 判断商品是否待支付
 * @param {Object} goods - 商品信息，getGoodsDetail 的返回值里的 info
 * @return {boolean} 商品是否待支付
 */
export const isGoodsWaitingPay = data =>
  Number(data.extension && data.extension.existWaitPayOrder) === 1

/**
 * 获取推荐商品
 * @param {Object} params - 请求参数
 * @param {string|number} params.goodsId - 商品ID
 */
// TODO 由于 组件和其他页面共用组件，展示数据涉及到驼峰和非驼峰的命名处理，因此需要兼容驼峰非驼峰命名，因此暂时不更改
export const getRecommendGoods = async params => {
  // const _params = {
  //   out_goods_id: params.goodsId,
  //   xenv: xenv(),
  // }
  const {
    channelId,
    loginInfo: { token },
    locationInfo: { cityId, lat, lng },
  } = GlobalEnv
  const _params = {
    token: token,
    source_id: channelId,
    city_id: cityId,
    lat: lat,
    lng: lng,
    out_goods_id: params.goodsId,
    xenv: xenv(),
  }
  // 售罄页请求猜你喜欢，新增参数
  if (isDyProgramH5()) {
    const showChannel =
      URLQueries.getQuery('live_status') === 'tiktok_live'
        ? EnumShowChannelType.Live
        : EnumShowChannelType.NoLive
    _params.show_channel = showChannel
    _params.partition_id = EnumPartitionID.DY
  }
  try {
    // const data = await goodsInit({
    //   mode: 'recommend',
    //   args: {
    //     extraParams: _params,
    //   },
    // })
    const data = await request.get(GlobalConfig.APIs.getRecommendList, _params)
    return {
      list: data && Array.isArray(data.lists) ? data.lists : [],
      event: {
        event_info: data.event_info,
        event_url: data.event_url,
      },
    }
  } catch (error) {
    return {
      list: [],
      event: null,
    }
  }
}
